import normalize from "json-api-normalizer";
import isEmpty from "lodash/isEmpty";
import queryString from "query-string";
import { batch } from "react-redux";

import { GET, PATCH } from "../../util/apiHelpers";
import { mapKeysToCamelCase, mapKeysToSnakeCase } from "../../util/formatHelpers";
import { receiveCandidates } from "../shared/candidateActions";

import { receiveContracts } from "../shared/contractActions";
import { receiveJobcasts } from "../shared/jobcastActions";
import {
  receivePayPeriods,
  fetchPayPeriodSuccess,
  receivePayPeriodIsApproving,
} from "../shared/payPeriodActions";
import { refetchLeftDrawerCounts } from "../shared/uiActions";

export function fetchPayPeriods(params = {}) {
  const queryStr = isEmpty(params) ? "" : `?${queryString.stringify(mapKeysToSnakeCase(params))}`;

  const url = `/api/v3/employer/pay_periods${queryStr}`;

  return (dispatch) =>
    GET(url).then((response) => {
      const normalized = normalize(response.data);

      batch(() => {
        dispatch(receiveJobcasts(normalized.jobcast));
        dispatch(receiveCandidates(normalized.candidate));
        dispatch(receivePayPeriods(normalized.payPeriod));
        dispatch(receiveContracts(normalized.contract));
      });

      return {
        items: normalized.payPeriod,
        metaData: mapKeysToCamelCase(response.data.meta),
        contracts: normalized.contract,
        candidates: normalized.candidate
      };
    });
}

export function disputePayPeriod(payPeriodId, dispute_explanation, edited_at) {
  const url = `/api/v3/employer/pay_periods/${payPeriodId}/dispute`;

  return (dispatch) =>
    PATCH(url, { dispute_explanation, edited_at }).then((response) => {
      const normalized = normalize(response.data);
      dispatch(fetchPayPeriodSuccess(normalized.payPeriod));
      dispatch(refetchLeftDrawerCounts());
    });
}

export function approvePayPeriod(payPeriodId, edited_at, allocations) {
  const url = `/api/v3/employer/pay_periods/${payPeriodId}/approve`;

  return (dispatch) => {
    dispatch(receivePayPeriodIsApproving(true));

    return PATCH(url, { edited_at, allocations }).then((response) => {
      const normalized = normalize(response.data);
      dispatch(fetchPayPeriodSuccess(normalized.payPeriod));
      dispatch(refetchLeftDrawerCounts());
      dispatch(receivePayPeriodIsApproving(false));
    });
  };
}

export function updatePayPeriod(payPeriodId, data) {
  const url = `/api/v3/employer/pay_periods/${payPeriodId}`;

  return (dispatch) => {
    return PATCH(url, data).then((response) => {
      const normalized = normalize(response.data);
      dispatch(fetchPayPeriodSuccess(normalized.payPeriod));
      dispatch(refetchLeftDrawerCounts());
    });
  };
}
